import React from 'react';
import { Box, Text, HStack, Badge, Spinner } from 'native-base';

/**
 * Shows the Doshii menu sync status for a venue.
 */
function MenuSyncStatus({ lastSync, syncStatus }) {
  if (!syncStatus || syncStatus === 'never') {
    return (
      <Box bg="coolGray.100" p={3} borderRadius="md" mb={3}>
        <Text fontSize="sm" color="coolGray.600">Menu has not been synced yet.</Text>
      </Box>
    );
  }

  var config = {
    synced: { color: 'success', label: 'Synced', bg: 'green.100' },
    stale: { color: 'warning', label: 'Stale', bg: 'yellow.100' },
    failed: { color: 'danger', label: 'Sync Failed', bg: 'red.100' },
  };

  var current = config[syncStatus] || config.synced;

  return (
    <Box bg={current.bg} p={3} borderRadius="md" mb={3}>
      <HStack alignItems="center" space={2}>
        <Badge colorScheme={current.color} variant="solid">{current.label}</Badge>
        {lastSync && (
          <Text fontSize="xs" color="coolGray.600">
            Last synced: {new Date(lastSync).toLocaleString()}
          </Text>
        )}
      </HStack>
    </Box>
  );
}

export default MenuSyncStatus;
